module.exports = __webpack_public_path__ + "img/logo-white.e2ef016e.png";